import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import {
  changeQBRLastStep,
  selectIsQbrDocumentFinalized,
  selectQBRLastStep,
} from 'partner360/features/QBR'

import styles from './NextButton.module.scss'

interface INextButtonProps {
  onClick?: () => void
  isButtonDisabled?: boolean
  isIncrementStep?: boolean
}

export const NextButton = ({ onClick, isButtonDisabled, isIncrementStep }: INextButtonProps) => {
  const lastStep = useSelector(selectQBRLastStep)
  const dispatch = useAppDispatch()
  const isFinalized = useSelector(selectIsQbrDocumentFinalized)

  const handleClick = useCallback(async () => {
    if (onClick) {
      await onClick()
    }
    if (isIncrementStep) {
      dispatch(changeQBRLastStep(lastStep + 1))
    }
  }, [onClick, lastStep, dispatch, isIncrementStep])

  if (isFinalized) {
    return null
  }

  return (
    <div className={styles.root}>
      <Button onClick={handleClick} disabled={isButtonDisabled}>
        <Translation text={TRANSLATION_KEYS.next} />
      </Button>
    </div>
  )
}
